import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { sharedStyles } from "../styles/shared";
import { property } from "lit/decorators/property.js";
import { when } from "lit/directives/when.js";

@customElement("bs-dots")
export class BsDots extends LitElement {
	static get styles() {
		return [
			sharedStyles,
			css`
				:host,
				#fade,
				#dots {
					position: absolute;
					inset: 0;
					pointer-events: none;
				}

				#dots {
					background-image: radial-gradient(var(--dots-color, var(--shade-lighter)) 2px, transparent 0px);
					background-size: 15px 15px;
				}

				#fade {
					background: radial-gradient(transparent 15%, var(--dots-fade-color, var(--background)) 100%);
				}
			`
		];
	}

	@property({ type: Boolean, reflect: true }) fade = false;

	render() {
		return html`
			<div id="dots"></div>
			${when(this.fade, () => html`<div id="fade"></div>`)}
		`;
	}
}
